import React from "react";
import type { EventVm } from "@/features/daily/components/command/health-view-model";

type Props = {
    events: EventVm[] | null;
    failed: boolean;
};

/**
 * B2: the latest transitions the read model actually observed, newest first. Nothing
 * is generated to fill a quiet stretch — an empty feed says so.
 */
export const EventsPanel: React.FC<Props> = ({ events, failed }) => (
    <section className="daily-panel daily-events" aria-labelledby="daily-events-title">
        <div className="daily-panel__head">
            <h2 id="daily-events-title">Últimos eventos</h2>
            <span className="daily-small daily-muted">Últimas 24 h</span>
        </div>
        {failed ? (
            <p className="daily-small daily-muted" role="status">No se pudieron cargar los eventos. Se reintentará en la próxima actualización.</p>
        ) : events === null ? (
            <p className="daily-small daily-muted" role="status">Cargando eventos…</p>
        ) : events.length === 0 ? (
            <p className="daily-small daily-muted">No se observó ninguna transición en las últimas 24 horas.</p>
        ) : (
            // A focusable, labelled region so the internal scroll works from the keyboard too.
            <div className="daily-events__scroll" tabIndex={0} role="region" aria-label="Últimos eventos, lista desplazable">
            <ol className="daily-event-list">
                {events.map((event) => (
                    <li key={event.key} className="daily-event">
                        <time dateTime={new Date(event.at).toISOString()}>{event.timeLabel}</time>
                        <div>
                            <span className="daily-event__title" data-tone={event.tone}>{event.title}</span>
                            <small>{event.detail}</small>
                        </div>
                    </li>
                ))}
            </ol>
            </div>
        )}
    </section>
);
